package one.healthium.insights.ui.components.items

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ColorModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.domain.models.TextStyleModel
import one.healthium.insights.ui.utils.resolve
import one.healthium.insights.ui.utils.toTextStyle
import one.healthium.ui.common.utils.toPaddingValues
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppButtonDefaults
import one.healthium.ui.compose.theme.AppTheme

@Composable
fun ContentButton(
    modifier: Modifier = Modifier,
    entry: ContentEntry.Button,
    onActionClicked: (ActionModel) -> Unit,
) {
    AppButton(
        modifier = modifier,
        minHeight = entry.height?.dp,
        colors = AppButtonDefaults.appButtonColors(
            containerColor = entry.containerColor?.resolve()
        ),
        onClick = { onActionClicked(entry.action) },
        contentPadding = entry.insets?.toPaddingValues(),
    ) {
        Text(
            text = entry.text,
            style = entry.style.toTextStyle()
        )
    }
}

@Composable
@Preview(showBackground = true)
private fun ContentButtonPreview() {
    AppTheme {
        Column(
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            ContentButton(
                entry = ContentEntry.Button(
                    text = "Button",
                    height = 37,
                    style = null,
                    containerColor = null,
                    action = ActionModel.Category(id = "id"),
                    insets = null
                ),
                onActionClicked = {}
            )

            ContentButton(
                entry = ContentEntry.Button(
                    text = "Button",
                    height = 37,
                    style = TextStyleModel(fontSize = 14, color = ColorModel.Hex(0xFF000000)),
                    containerColor = ColorModel.Hex(0xFFF8F6F4),
                    action = ActionModel.Category(id = "id"),
                    insets = null
                ),
                onActionClicked = {}
            )
        }
    }
}